"use client";

import React from "react";
import { LucideIcon } from "lucide-react";

interface EmptyStateProps {
  icon?: LucideIcon;
  title?: string;
  description?: string;
  action?: React.ReactNode;
  size?: "sm" | "md" | "lg";
  className?: string;
}

const sizeClasses = {
  sm: {
    icon: "h-8 w-8",
    title: "text-base",
    description: "text-sm",
    spacing: "py-4"
  },
  md: {
    icon: "h-12 w-12", 
    title: "text-lg",
    description: "text-base",
    spacing: "py-8"
  },
  lg: {
    icon: "h-16 w-16",
    title: "text-xl", 
    description: "text-lg",
    spacing: "py-12"
  }
};

export function EmptyState({
  icon: Icon,
  title = "No items found",
  description,
  action,
  size = "md",
  className = ""
}: EmptyStateProps) {
  const sizes = sizeClasses[size];

  return (
    <div className={`text-center text-muted-foreground ${sizes.spacing} ${className}`}>
      {Icon && (
        <Icon className={`${sizes.icon} mx-auto mb-4 opacity-50`} />
      )}
      <h3 className={`font-semibold ${sizes.title} mb-2`}>
        {title}
      </h3>
      {description && (
        <p className={`${sizes.description} mb-4`}>
          {description}
        </p>
      )}
      {action}
    </div>
  );
}
